export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "Weather Data: Station:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dane Pogodowe Stacji:"])},
        "Relative Pressure:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ciśnienie względne:"])},
        "Temperature:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Temperatura:"])},
        "Wind:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiatr:"])},
        "Speed:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość:"])},
        "Gust:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Porywy:"])},
        "Wind Direction:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kierunek Wiatru:"])},
        "Humidity:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wilgotność:"])},
        "Rain:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opady:"])},
        "Last Hour:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ost. godz.:"])},
        "Last 24 Hours:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ost. 24 godz.:"])},
        "From Midnight:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Od północy:"])}
      }
    }
  })
}
